import "./Success.scss";

import clsx from "clsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Info, MenuPartner, Newsletter, Send } from "@/assets/icons/icons";
import { Button } from "@/components/Interface/Button/Button";
const Success = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "success",
  });
  const navigate = useNavigate();

  // Redirect if accessed directly via URL
  useEffect(() => {
    // Check if user came from the proper flow by checking if there's a success state
    const hasValidAccess = sessionStorage.getItem("orderSuccess") === "true";

    if (!hasValidAccess) {
      navigate("/portal/add-device", { replace: true });
    } else {
      // Clear the success flag after successful access to prevent back navigation
      sessionStorage.removeItem("orderSuccess");
    }
  }, [navigate]);

  return (
    <div id="success-wrapper" className={clsx("tile-width-wrapper")}>
      <div className="management-tile active">
        <div className="flex flex-col items-center">
          <Send className="mt-6" width={60} height={60} color="#00dcc3" />
          <h1 className="mb-6 mt-10 text-center font-semibold text-primary-100">
            {t("successMessage")}
          </h1>
        </div>
        <hr className="mb-12 mt-10 border-primary-25" />
        <div className="mx-auto flex max-w-2xl flex-col">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <Newsletter width={24} height={24} />
              <h3 className="font-semibold text-secondary-100">
                {t("section1.title")}
              </h3>
            </div>
            <p>{t("section1.subtitle")}</p>
            <div className="flex list-disc flex-col gap-1 pl-8">
              <li>{t("section1.list.1")}</li>
              <li>{t("section1.list.2")}</li>
              <li>{t("section1.list.3")}</li>
            </div>
          </div>
          <div className="flex flex-col gap-4 pt-10">
            <div className="flex items-center gap-4">
              <MenuPartner width={24} height={24} fill="#0014FF" />
              <h3 className="font-semibold text-secondary-100">
                {t("section2.title")}
              </h3>
            </div>
            <p>{t("section2.subtitle")}</p>
            <div className="flex list-decimal flex-col gap-1 pl-8">
              <li>{t("section2.list.1")}</li>
              <li>{t("section2.list.2")}</li>
              <p className="font-small">{t("section2.list.3")}</p>
            </div>

            <div className="flex items-center gap-2 pl-2">
              <Info className="text-primary-100" />
              <p className="font-small">{t("section2.hint")}</p>
            </div>
          </div>
        </div>
        <hr className="mb-12 mt-10 border-primary-25" />
        <div className="flex justify-end">
          <Button
            fullWidth
            className="accent mt-2 smPlus:ml-auto smPlus:w-fit"
            onClick={() => navigate("/portal/cockpit")}
          >
            {t("back")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Success;
